var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5907 2.91409C14.0137 2.12949 12.0841 1.66797 9.99997 1.66797C7.91592 1.66797 5.98625 2.12949 4.4093 2.91409C3.63598 3.29885 3.24933 3.49124 2.87467 4.09612C2.5 4.70101 2.5 5.2867 2.5 6.45809V9.36555C2.5 14.1017 6.28529 16.735 8.47755 17.8628C9.08888 18.1774 9.39455 18.3346 9.99997 18.3346C10.6054 18.3346 10.9111 18.1774 11.5225 17.8628C13.7147 16.735 17.5 14.1017 17.5 9.36555V6.45809C17.5 5.28671 17.5 4.70102 17.1253 4.09612C16.7506 3.49123 16.364 3.29885 15.5907 2.91409Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 9.16536C10.9201 9.16536 11.6663 8.4192 11.6663 7.4987C11.6663 6.57822 10.9201 5.83203 9.99964 5.83203C9.07922 5.83203 8.33301 6.57822 8.33301 7.4987C8.33301 8.4192 9.07922 9.16536 9.99964 9.16536ZM9.99964 9.16536V11.2487M9.99964 11.2487V12.4987C9.99964 12.9589 10.3728 13.332 10.833 13.332H11.6663M9.99964 11.2487H11.2496",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldKey);
export default __webpack_public_path__ + "static/media/shield-key.6cdc9f6924f16259221cd202851c4267.svg";
export { ForwardRef as ReactComponent };